import { Alert, Button, Divider, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModelPage from "../../../../../layout/ModelPage";
import { URL_BASE_PAGOS2 } from "../../../../../constants/url";
import { notification } from "../../../../../context/actions/notificationActions";
import { startGetOrdenesValidarFactura } from "../../../../../context/actions/pagos2Actions";
import {
  composeErrorNotification,
  composeSuccessNotification,
} from "../../../../../utils/composeNotification";
import { postFile } from "../../../../../utils/fetch";

export default function ModalCargarFactura({ showModal, setShowModal, ordenPagoID, loading, setLoading, onSuccess, onCancel, esPagoDirecto = false, asistencias = [] }) {
  const dispatch = useDispatch();
  const { usuarioID } = useSelector((state) => state.userReducer.user);
  const [body, setBody] = useState({});

  const estaVacioNull = (valor) => {
    if (valor === "" || valor === null || valor === undefined) {
      return true;
    }
    return false;
  };

  const camposError = () => {
    let salida = false;
    if (estaVacioNull(body.facturaPDF)) salida = true;
    if (estaVacioNull(body.facturaXML)) salida = true;
    if (estaVacioNull(body.verificacionFactura)) salida = true;
    return salida;
  };

  const props1 = {
    beforeUpload: (facturaPDF) => {
      setBody({ ...body, facturaPDF });
      return false;
    },
    maxCount: 1,
    showUploadList: false,
  };

  const props2 = {
    beforeUpload: (facturaXML) => {
      setBody({ ...body, facturaXML });
      return false;
    },
    maxCount: 1,
    showUploadList: false,
  };

  const props3 = {
    beforeUpload: (verificacionFactura) => {
      setBody({ ...body, verificacionFactura });
      return false;
    },
    maxCount: 1,
    showUploadList: false,
  };

  const handleClick = async () => {
    if (camposError()) {
      dispatch(
        notification(
          composeErrorNotification("Error", "Todos los archivos son requeridos")
        )
      );
      return;
    }

    setLoading(true);

    try {
      let formdata = new FormData();

      if (esPagoDirecto) {
        formdata.append("FacturaPDF", body.facturaPDF);
        formdata.append("FacturaXML", body.facturaXML);
        formdata.append("VerificacionFactura", body.verificacionFactura);
        formdata.append("UsuarioID", usuarioID);

        const asistenciasIds = asistencias.map(a => a.asistenciaID).join(',');
        formdata.append("Asistencias", asistenciasIds);
      } else {
        formdata.append("mimetype", "application/pdf");
        formdata.append("facturaPDF", body.facturaPDF);
        formdata.append("facturaXML", body.facturaXML);
        formdata.append("fechaPagoRequerido", body.fechaPagoRequerido);
        formdata.append("verificacionFactura", body.verificacionFactura);
        formdata.append("ordenPagoID", ordenPagoID);
        formdata.append("tipo", 0);
        formdata.append("usuarioID", usuarioID);
      }

      const url = esPagoDirecto
        ? `${URL_BASE_PAGOS2}/PagoDirecto`
        : `${URL_BASE_PAGOS2}/DocumentosFacturacion`;

      const result = await postFile(url, formdata);

      if (result.code === 0) {
        dispatch(notification(composeSuccessNotification(result.data)));
        dispatch(startGetOrdenesValidarFactura());
        setBody({});
        if (onSuccess) {
          await onSuccess(result.data);
        } else {
          setShowModal(false);
        }
      } else {
        dispatch(
          notification(
            composeErrorNotification(
              esPagoDirecto ? "Error de conexión - Pago Directo" : "Error de conexion - DocumentosFacturacion",
              `${result.error}`
            )
          )
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleFecha = ({ target }) => {
    setBody({
      ...body,
      fechaPagoRequerido: target.value
    });
  };

  const ok = () => {
    handleClick();
  };

  const cancel = () => {
    setBody({});
    if (onCancel) {
      onCancel();
    } else {
      setShowModal(false);
    }
  };

  return (
    <ModelPage
      titulo={esPagoDirecto ? "Pago Directo - Cargar Factura" : `Cargar Factura - OP ${ordenPagoID}`}
      isVisible={showModal}
      handleOk={ok}
      handleCancel={cancel}
      confirmLoading={loading}
      className="pagos-v2-modal"
      width={350}
    >
      <div style={{ textAlign: "center" }}>
        <div className="tituloPequeño">Factura PDF emitida por el proveedor</div>

        <Upload {...props1} style={{ width: "100%" }}>
          <Button
            style={{ marginTop: 20 }}
            icon={<UploadOutlined />}
          >
            Seleccione documento
          </Button>
        </Upload>
        <div style={{ marginTop: 8 }}>{body.facturaPDF?.name}</div>

        <Divider />
        <div className="tituloPequeño">Factura XML emitida por el proveedor</div>

        <Upload {...props2} style={{ width: "100%" }}>
          <Button
            style={{ marginTop: 20 }}
            icon={<UploadOutlined />}
          >
            Seleccione documento
          </Button>
        </Upload>
        <div style={{ marginTop: 8 }}>{body.facturaXML?.name}</div>

        <Divider />
        <div className="tituloPequeño">
          Verificacion de factura por SAT
        </div>
        <div style={{ marginTop: 8, display: "inline-block" }}>
          <Alert
            type='warning'
            showIcon
            style={{ fontSize: "11px" }}
            message={"Por favor verifica que los folios fiscales coincidan"}
          />
        </div>

        <Upload {...props3} style={{ width: "100%" }}>
          <Button
            style={{ marginTop: 20 }}
            icon={<UploadOutlined />}
          >
            Seleccione documento
          </Button>
        </Upload>
        <div style={{ marginTop: 8 }}>{body.verificacionFactura?.name}</div>

      </div>
    </ModelPage>
  );
}
